import React, { Component } from 'react';
import '../myutils';
import {
    translate,
} from 'react-admin'; 
import BookIcon from '@material-ui/icons/Book'; 
import {IconButton} from '@material-ui/core';
import PhoneInTalk from '@material-ui/icons/PhoneInTalk';

export const TemplateIcon = BookIcon;

class PickUpButton extends Component {

    state = {
        open: false,
      };
      constructor(props) {
        super(props);
        this.state = {
          record: false
        }
    
      }

      render() {
        return (
          <div style={{float:"right"}}>
            <IconButton onClick={(e)=>e.stopPropagation()}>
                <PhoneInTalk></PhoneInTalk>
            </IconButton>
         </div>
        );
    }
}

export default translate(PickUpButton);
